const invertedMessages = {
  Close: 'CloseLabel',
  User: 'User_LABEL.ATTESTATIONS',
  Account: 'Account_LABEL.ATTESTATIONS',
  Role: 'Role_LABEL.ATTESTATIONS',
  Entitlement: 'Ent_LABEL.ATTESTATIONS',
  'Child Entitlement': 'Ent2_LABEL.ATTESTATIONS',
};

export default invertedMessages;
